import { createSelector } from 'reselect'

/**
 * Select the analytic state slice
 * @param {object} state - Redux state
 * @returns {object} Analytic state
 */
export const selectAnalytic = (state) => state.analytic

/**
 * Select the Analytics instance
 * @param {object} state - Redux state
 * @returns {object} Analytics instance
 */
export const selectAnalytics = createSelector(
  selectAnalytic,
  (analytic) => analytic.analytics
)
